import React, { useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
const API = process.env.REACT_APP_API_URL || 'http://localhost:5001';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token');

  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | success | error
  const [error, setError] = useState('');

  if (!token) {
    return (
      <div style={s.page}>
        <div style={s.card}>
          <div style={s.icon}>❌</div>
          <h2 style={s.title}>Invalid reset link</h2>
          <p style={s.sub}>This link is missing or malformed. Please request a new one.</p>
          <Link to="/forgot-password" style={s.btn}>Request New Link</Link>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!newPassword) return setError('Please enter a new password.');
    if (newPassword.length < 6) return setError('Password must be at least 6 characters.');
    if (newPassword !== confirm) return setError('Passwords do not match.');

    setStatus('loading');
    try {
      const res = await fetch(`${API}/api/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword })
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || 'Something went wrong.');
        setStatus('idle');
      } else {
        setStatus('success');
        setTimeout(() => navigate('/login'), 3000);
      }
    } catch {
      setError('Something went wrong. Please try again.');
      setStatus('idle');
    }
  };

  if (status === 'success') {
    return (
      <div style={s.page}>
        <div style={s.card}>
          <div style={s.icon}>✅</div>
          <h2 style={s.title}>Password updated!</h2>
          <p style={s.sub}>Your password has been changed successfully. Redirecting you to login in a moment...</p>
          <Link to="/login" style={s.btnLink}>Go to Login →</Link>
        </div>
      </div>
    );
  }

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.icon}>🔑</div>
        <h2 style={s.title}>Set a new password</h2>
        <p style={s.sub}>Choose something strong. At least 6 characters.</p>

        <form onSubmit={handleSubmit} style={s.form}>
          <div>
            <label style={s.label}>New password</label>
            <input
              type="password"
              placeholder="New password"
              value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
              style={s.input}
              autoFocus
            />
          </div>
          <div>
            <label style={s.label}>Confirm password</label>
            <input
              type="password"
              placeholder="Confirm new password"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              style={s.input}
            />
          </div>
          {error && <p style={s.error}>{error}</p>}
          <button type="submit" style={s.btn} disabled={status === 'loading'}>
            {status === 'loading' ? 'Updating...' : 'Update Password'}
          </button>
        </form>

        <Link to="/login" style={s.backLink}>← Back to login</Link>
      </div>
    </div>
  );
}

const s = {
  page: { minHeight: '100vh', background: '#0f172a', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif' },
  card: { background: '#1e293b', borderRadius: '16px', padding: '48px 40px', maxWidth: '420px', width: '100%', textAlign: 'center', boxShadow: '0 25px 50px rgba(0,0,0,0.4)' },
  icon: { fontSize: '48px', marginBottom: '16px' },
  title: { color: '#f1f5f9', fontSize: '24px', fontWeight: '700', margin: '0 0 8px' },
  sub: { color: '#94a3b8', fontSize: '15px', lineHeight: '1.6', margin: '0 0 24px' },
  form: { display: 'flex', flexDirection: 'column', gap: '14px', textAlign: 'left' },
  label: { display: 'block', color: '#94a3b8', fontSize: '13px', fontWeight: '600', marginBottom: '6px' },
  input: { width: '100%', background: '#0f172a', border: '1px solid #334155', borderRadius: '8px', padding: '12px 14px', color: '#f1f5f9', fontSize: '15px', outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box' },
  btn: { display: 'block', background: 'linear-gradient(135deg, #1e3a8a, #4f46e5)', color: 'white', border: 'none', borderRadius: '8px', padding: '13px', fontSize: '15px', fontWeight: '700', cursor: 'pointer', width: '100%', textAlign: 'center', textDecoration: 'none', marginTop: '4px' },
  btnLink: { display: 'inline-block', marginTop: '16px', background: 'linear-gradient(135deg, #1e3a8a, #4f46e5)', color: 'white', padding: '12px 28px', borderRadius: '8px', textDecoration: 'none', fontWeight: '700', fontSize: '15px' },
  error: { color: '#f87171', fontSize: '13px', margin: '0' },
  backLink: { display: 'inline-block', marginTop: '24px', color: '#6366f1', fontSize: '14px', textDecoration: 'none' },
};
